import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HasIdClass;
function HasId() {
  if (HasIdClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HasId');
    HasIdClass = $;
  }
  return HasIdClass;
}
//region block: exports
export {
  HasId as HasId2loj0ucxxxo6d,
};
//endregion

//# sourceMappingURL=HasId.mjs.map
